import { SubmissionErrors } from 'final-form';
import React from 'react';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
import {
  Button,
  CardBody,
  CardTitle,
  Col,
  Fade,
  Form as FormComponent,
  FormGroup,
  Label,
  Row,
  Spinner,
  Toast,
  ToastBody,
  ToastHeader,
} from 'reactstrap';
import { CsvGenerator } from '../../../../containers/CsvGenerator';

const RenderSelect = ({
  name,
  label,
  placeholder,
  disabled,
  options,
  loading,
  searchable,
  initialValue,
}: {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  loading?: boolean;
  searchable?: boolean;
  options?: { value: string; label: string }[];
  initialValue?: { value: string; label: string };
}) => (
  <FormGroup row>
    <Label for={name} sm={4} md={3}>
      {label}
    </Label>
    <Col sm={8} md={9}>
      <Field<{ value: string; label: string }>
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        initialValue={initialValue}
        validate={(value: { value: string } | undefined) =>
          !value ? 'This field is required' : undefined
        }>
        {({ input, meta, ...rest }) => (
          <div>
            <Select
              {...input}
              {...rest}
              type="text"
              invalid={!!meta.error}
              options={options}
              isClearable
              isSearchable={searchable}
              isDisabled={disabled}
              isLoading={loading}
            />
            {
              <span
                className={
                  meta.error ? 'text-danger visible' : 'text-danger invisible'
                }>
                {meta.error ? meta.error : 'All good'}
              </span>
            }
          </div>
        )}
      </Field>
    </Col>
  </FormGroup>
);

interface PatientExportValues {
  exportType?: string;
  patientId?: string;
  organizationId?: string;
  questionnaireId?: string;
}
const initialValue = { value: 'csv', label: 'CSV' };

const OrganizationReportTabComponent = (props: {
  initialValues?: PatientExportValues;
  onSubmit: (
    values?: PatientExportValues,
  ) =>
    | SubmissionErrors
    | Promise<SubmissionErrors | undefined>
    | undefined
    | void;
}) => {
  return (
    <Fade>
      <CardBody>
        <CardTitle>
          <h3>Patient Reports</h3>
        </CardTitle>
        <Form onSubmit={props.onSubmit} initialValues={props.initialValues}>
          {({
            handleSubmit,
            form,
            submitting,
            submitSucceeded,
            pristine,
            hasValidationErrors,
          }) => (
            <Row>
              <Col>
                <FormComponent onSubmit={handleSubmit}>
                  <RenderSelect
                    name="export"
                    placeholder=" JSON / CSV / PDF"
                    label="Export"
                    initialValue={initialValue}
                    options={[{ value: 'csv', label: 'CSV' }]}
                  />
                  <Col className="d-flex justify-content-end">
                    <Button
                      disabled={pristine}
                      className="mr-2"
                      color="warning"
                      onClick={() => form.reset()}>
                      Reset
                    </Button>
                    <Button color="success" disabled={hasValidationErrors}>
                      {submitting ? <Spinner size="sm" /> : 'Submit'}
                    </Button>
                  </Col>
                </FormComponent>
              </Col>
              <Col xs={3} md={3} xl={6}>
                <Toast className="w-100 m-auto">
                  <ToastHeader>CSV Generator</ToastHeader>
                  <ToastBody>
                    {submitting ? (
                      <div className="text-center">
                        <Spinner></Spinner>
                      </div>
                    ) : submitSucceeded ? (
                      <CsvGenerator />
                    ) : (
                      'Please submit your request to get snapshot of the data'
                    )}
                  </ToastBody>
                </Toast>
              </Col>
            </Row>
          )}
        </Form>
      </CardBody>
    </Fade>
  );
};
const OrganizationReportTab = () => (
  <OrganizationReportTabComponent
    onSubmit={() => {
      return undefined;
    }}
  />
);
export default OrganizationReportTab;
